import { render } from "./CardCouponRecord.vue?vue&type=template&id=1ba66e0a&scoped=true"
import script from "./CardCouponRecord.vue?vue&type=script&lang=js"
export * from "./CardCouponRecord.vue?vue&type=script&lang=js"

import "./CardCouponRecord.vue?vue&type=style&index=0&id=1ba66e0a&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba66e0a"]])

export default __exports__